import { TourStep } from '../models/tour-step.model';

export const IB_SIDEBAR_TOUR_STEPS: TourStep[] = [
  {
    id: 'dashboard',
    targetId: 'tour-dashboard',
    descriptionKey: 'TOUR.Dashboard.Desc',
  },
  {
    id: 'statistics',
    targetId: 'tour-statistics',
    descriptionKey: 'TOUR.Statistics.Desc',
  },
  {
    id: 'clients',
    targetId: 'tour-clients',
    descriptionKey: 'TOUR.Clients.Desc',
  },
  {
    id: 'financial',
    targetId: 'tour-financial',
    descriptionKey: 'TOUR.Financial.Desc',
  },
  {
    id: 'verification',
    targetId: 'tour-verification',
    descriptionKey: 'TOUR.KYC.Desc',
  },
  {
    id: 'ib-plan',
    targetId: 'tour-ib-plan',
    descriptionKey: 'TOUR.IBPlan.Desc',
  },
  {
    id: 'tickets',
    targetId: 'tour-tickets',
    descriptionKey: 'TOUR.Tickets.Desc',
  },
  {
    id: 'bank',
    targetId: 'tour-bank',
    descriptionKey: 'TOUR.Banks.Desc',
  },
  {
    id: 'trader-panel',
    targetId: 'tour-trader-panel',
    descriptionKey: 'TOUR.TraderPanel.Desc',
  },
  {
    id: 'profile',
    targetId: 'tour-profile',
    descriptionKey: 'TOUR.Profile.Desc',
  },
  {
    id: 'language',
    targetId: 'tour-language',
    descriptionKey: 'TOUR.Language.Desc',
  },
  {
    id: 'theme',
    targetId: 'tour-theme',
    descriptionKey: 'TOUR.Theme.Desc',
  },
  {
    id: 'logout',
    targetId: 'tour-logout',
    descriptionKey: 'TOUR.Logout.Desc',
  },
];
